import URL from 'url';
import configHandler from '../configHandler';

const conditionalRedirect = (condition, callback) => {
  if (condition) {
    callback();
    return true;
  }
  return false;
};

const redirectToSTS = state => {
  const config = configHandler();

  const authUri = URL.parse(config.EXTERNAL_OAUTH_URL),
    clientId = config.EXTERNAL_OAUTH_KEY,
    redirectUri = encodeURIComponent(config.TAXONLINE_SME_DASHBOARD_OAUTH_REDIRECT_URI_ARL),
    scope = `${config.EXTERNAL_AGENCY_API_SCOPE} CompanyFile`;

  authUri.pathname = 'oauth2/account/authorize';
  authUri.search = `client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}`;
  console.log(URL.format(authUri));
  window.location = URL.format(authUri);
};

const redirectToNotFound = replace => {
  replace('/nomatch');
};

export default (nextState, replace) => {
  const url = URL.parse(window.location.href, true);
  conditionalRedirect(url.query && url.query.logoff === 'true' && url.query.state,
    () => redirectToSTS(url.query.state))
  || redirectToNotFound(replace);
}


// WEBPACK FOOTER //
// ./src/app/helpers/handleWildcardRoute.js